import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { supabase } from '../../../lib/supabaseClient';

const BeforeAfterPreview = () => {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let alive = true;

    const fetchLatest = async () => {
      setIsLoading(true);
      const { data, error } = await supabase
        .from('before_after_posts')
        .select('id, image_url, created_at')
        .eq('is_published', true)
        .order('created_at', { ascending: false })
        .limit(3);

      if (!alive) return;

      if (error) {
        setPosts([]);
        setIsLoading(false);
        return;
      }

      setPosts(Array.isArray(data) ? data : []);
      setIsLoading(false);
    };

    fetchLatest();

    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="bg-card rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl p-6 sm:p-8">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="text-2xl sm:text-3xl font-bold text-foreground">비포&애프터</h2>
          <p className="mt-2 text-sm text-muted-foreground">최근 작업 결과를 확인해보세요</p>
        </div>
        <Button
          variant="ghost"
          iconName="ChevronRight"
          iconPosition="right"
          onClick={() => navigate('/before-after')}
        >
          전체 보기
        </Button>
      </div>

      <div
        className="mt-6 grid grid-cols-3 gap-3"
        role="button"
        tabIndex={0}
        onClick={() => navigate('/before-after')}
        onKeyDown={(e) => {
          if (e?.key === 'Enter' || e?.key === ' ') {
            navigate('/before-after');
          }
        }}
      >
        {isLoading
          ? Array.from({ length: 3 }).map((_, idx) => (
              <div key={idx} className="aspect-[7/10] w-full overflow-hidden rounded-md bg-muted" />
            ))
          : posts?.length > 0
            ? posts?.map((post) => (
                <div key={post?.id} className="group">
                  <div className="aspect-[7/10] w-full overflow-hidden rounded-md bg-muted">
                    <Image
                      src={post?.image_url}
                      alt={'Before & After'}
                      className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.02]"
                    />
                  </div>
                </div>
              ))
            : (
                <div className="col-span-3 rounded-md border border-dashed border-border bg-background p-6 text-center">
                  <div className="mx-auto flex h-10 w-10 items-center justify-center rounded-full bg-muted">
                    <Icon name="Image" size={20} color="var(--color-muted-foreground)" />
                  </div>
                  <p className="mt-3 text-sm text-muted-foreground">등록된 비포&애프터가 아직 없습니다</p>
                </div>
              )}
      </div>
    </div>
  );
};

export default BeforeAfterPreview;
